import { render } from "./device-type.vue?vue&type=template&id=183ba22e"
import script from "./device-type.vue?vue&type=script&lang=js"
export * from "./device-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__